<template>
  <Loading v-if="componentLoading" :style="style" />
  <Chart v-else-if="visible" class="compare-line-chart" :option="chartConfig" :style="style"></Chart>
</template>

<script lang="ts" setup>
import Chart from "@p-v/packages/Charts/BaseChart/index.vue"
import Loading from "@p-v/packages/Loading.vue"
import { ref, watch } from "vue"
import { cloneDeep, defaultsDeep } from "lodash-es"
import config from "./config"
import useToggle from "@p-v/hooks/useToggle"
import type { GaugeChartProps } from "./index.d"
import { EChartsOption } from "echarts"

const componentLoading = ref<boolean>(true)

const props = withDefaults(defineProps<GaugeChartProps>(), {
  data: () => ({
    value: 0,
  }),
  config: () => ({}),
  style: () => ({}),
  show: () => true,
})
const { visible, show, hide, changeVisible } = useToggle(props.show)

const chartConfig = ref(cloneDeep(config))

// watch(
//   () => props,
//   propsData => {
//     // console.log('watch props', propsData);
//     if (propsData.data) {
//       const result = componentPropEngine(propsData)
//       // console.log('result', result.series);
//       chartConfig.value = result
//     } else {
//       chartConfig.value = cloneDeep(config)
//     }
//   },
//   {
//     immediate: true,
//     deep: true,
//   },
// )

/**
 * 数据处理
 * @param config
 * @param dataList
 */
function componentPropEngine(propsData: GaugeChartProps): EChartsOption {
  const { data, config: _config } = propsData
  const newConfig = cloneDeep(config)
  const configFromProp = cloneDeep(_config)
  const configResult = defaultsDeep(configFromProp, props.config, newConfig)

  configResult.series[0].data[0] = defaultsDeep(data, configResult.series[0].data[0])

  // 移除暂无数据的文本
  // delete configResult.graphic;
  configResult.graphic[0].invisible = true

  return configResult
}
const loading = () => {
  componentLoading.value = true
}
const setData = (
  data:
    | {
        value: number
        name?: string
      }
    | {
        data: {
          value: number
          name?: string
        }
        option?: EChartsOption
      },
  option?: EChartsOption,
) => {
  if ("data" in data) {
    option = data.option
    data = data.data
  }
  const result = componentPropEngine({ data, config: option })
  chartConfig.value = result
  componentLoading.value = false
}
defineExpose({ setData, loading, show, hide, changeVisible })
</script>

<style lang="scss">
.compare-line-chart {
  height: 100%;
}
</style>
.
